import { useAccount, useMsal } from '@azure/msal-react';
import type React from 'react';
import { runtimeConfig } from '@/runtimeConfig';

export const About: React.FC = () => {
  const { accounts } = useMsal();
  const account = useAccount(
    accounts[0] || {
      homeAccountId: '',
      localAccountId: '',
      environment: '',
      tenantId: '',
      username: '',
    },
  );

  return (
    <div className="p-4 space-y-2 text-sm text-foreground">
      {account && (
        <div className="mb-4 pb-4 border-b border-border">
          <div className="flex justify-between">
            <span className="font-semibold">User:</span>
            <span>{account.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Email:</span>
            <span>{account.username}</span>
          </div>
        </div>
      )}
      <div className="flex justify-between">
        <span className="font-semibold">Version:</span>
        <span>{runtimeConfig.AppVersion.asString()}</span>
      </div>
      <div className="flex justify-between">
        <span className="font-semibold">Build Date:</span>
        <span>{runtimeConfig.BuildDate.asString()}</span>
      </div>
      <div className="flex justify-between">
        <span className="font-semibold">API URL:</span>
        <span className="font-mono">{runtimeConfig.ApiBaseUrl.asString()}</span>
      </div>
    </div>
  );
};
